import { generateHTML } from "@tiptap/html"
import StarterKit from "@tiptap/starter-kit"
import cn from "classnames"

import FaIcon from "components/FontAwesomeIcon"
import { stripHtml } from "utils/helpers"

import type { JSONContent } from "@tiptap/react"
const HelpText: React.FC<
  JSX.IntrinsicElements["div"] & {
    variant: "absolute" | "inline"
    question?: string
    helpContent: JSONContent
  }
> = ({ variant, question, helpContent, ...rest }) => {
  const wrapperClass = cn("group", {
    "absolute top-0 right-0": variant === "absolute",
    "relative inline-block": variant === "inline",
    [rest?.className as string]: !!rest?.className
  })
  rest = { ...rest, className: wrapperClass }

  const html = generateHTML(helpContent, [StarterKit])

  const hasContent = stripHtml(html).length > 0

  return hasContent ? (
    <div {...rest}>
      <div className="flex items-center gap-2 p-2 bg-white shadow font-bold text-sm cursor-pointer">
        {question && <p className="my-0">{question}</p>}
        <FaIcon icon="info" className="mb-[5px]" />
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: generateHTML(helpContent, [StarterKit])
        }}
        className="absolute top-full right-0 bg-gray-100 shadow font-bold pt-2 px-2 text-sm z-10 group-hover:block hidden w-[20rem]"
      />
    </div>
  ) : null
}

export default HelpText
